<template>
<div class="Yodapp">
    <div class="container mb-5" id="nav">
        <b-navbar>
            <template slot="brand">
                <b-navbar-item tag="router-link" :to="{ path: '/' }">
                    <img alt="Yodapp" src="../assets/logo.svg" />
                </b-navbar-item>
            </template>
            <template slot="end">
                <b-navbar-item href="#" id="welcome">
                    Que a Força (qualidade) esteja com você!
                </b-navbar-item>
                <b-navbar-item tag="div">
                    <div class="buttons">
                        <a href="/new" class="button is-success"><strong>Novo</strong></a>
                    </div>
                </b-navbar-item>
            </template>
        </b-navbar>
    </div>

    <div class="container">
        <b-carousel>
            <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                <section class="hero is-medium" v-bind:style="carousel.bg">
                    <div class="hero-body has-text-centered">
                        <h1 class="title">{{ carousel.text }}</h1>
                    </div>
                </section>
            </b-carousel-item>
        </b-carousel>

        <div class="usuarios mt-5">
            <section>
                <b-table :data="isEmpty ? [] : usuarios" :bordered="isBordered" :striped="isStriped" :narrowed="isNarrowed" :hoverable="isHoverable" :loading="isLoading" :focusable="isFocusable" :mobile-cards="hasMobileCards">
                    <b-table-column field="nome" label="Nome" v-slot="props">
                        <b-icon pack="fas" :icon="pegaOrdem(props.row.ordem)" :type="ehtipoJedi(props.row.tipoJedi)"> </b-icon>
                        {{ props.row.nome }}
                    </b-table-column>

                    <b-table-column field="email" label="Email" v-slot="props">
                        {{ props.row.email }}
                    </b-table-column>

                    <b-table-column field="data" label="Data de nascimento" v-slot="props">
                        <span class="tag is-primary">
                            {{ new Date(props.row.niver).toLocaleDateString() }}
                        </span>
                    </b-table-column>

                    <b-table-column label="Instagram" v-slot="props">
                        {{ props.row.instagram }}
                    </b-table-column>

                    <b-table-column label="" v-slot="props">
                        <b-button type="is-danger" icon-right="delete" @click="removeUsuario(props.row.id)" />
                    </b-table-column>

                </b-table>
            </section>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: {
        msg: String,
    },
    data() {
        return {
            usuarios: [],
            carousels: [{
                    text: "O QA usa o BDD para colaborar com o time, não somente para testes.",
                    bg: {
                        backgroundImage: `url(${require('../assets/bg-yoda1.png')})`
                    },
                },
                {
                    text: "Bugs e retestes no FDS. Ao lado sombrio eles pertencem.",
                    bg: {
                        backgroundImage: `url(${require('../assets/bg-yoda2.png')})`
                    },
                },
                {
                    text: "Sempre testando é o Futuro.",
                    bg: {
                        backgroundImage: `url(${require('../assets/bg-yoda3.png')})`
                    },
                },
                {
                    text: "Que a Força (qualidade) esteja com você.",
                    bg: {
                        backgroundImage: `url(${require('../assets/bg-yoda4.png')})`
                    },
                },
                {
                    text: "Para aprender Automação de Testes, praticar você deve!",
                    bg: {
                        backgroundImage: `url(${require('../assets/bg-yoda5.png')})`
                    },
                },
            ],
            isEmpty: false,
            isBordered: false,
            isStriped: false,
            isNarrowed: false,
            isHoverable: false,
            isFocusable: false,
            isLoading: false,
            hasMobileCards: true,
        };
    },
    methods: {
        ehtipoJedi(valor) {
            if (valor === "Cavaleiro Jedi") return "is-success";
            if (valor === "Padawan") return "is-primary";
            return '';
        },
        pegaOrdem(valor) {
            const ordem = parseInt(valor);
            if (ordem === 1) return "jedi";
            if (ordem === 2) return "skull";
            if (ordem === 3) return "user";
            return null;
        },
        removeUsuario(usuarioId) {
            let usuarios = JSON.parse(localStorage.getItem('usuarios'))
            usuarios = usuarios.filter(item => item.id != usuarioId)

            localStorage.setItem('usuarios', JSON.stringify(usuarios))
            this.usuarios = JSON.parse(localStorage.getItem('usuarios'));
        }
    },
    created() {

        const usuarios = JSON.parse(localStorage.getItem('usuarios'))

        if (!usuarios) {
            const list = [{
                id: this.$faker().phone.phoneNumberFormat(),
                nome: "Luke Skywalker",
                ordem: 1,
                email: "luke@jedi.com",
                niver: "1983/02/18",
                instagram: "@lukeskywalker",
                tipoJedi: "Cavaleiro Jedi",
                comunicacoes: true
            }]

            localStorage.setItem('usuarios', JSON.stringify(list))
        }

    },
    mounted() {
        this.usuarios = JSON.parse(localStorage.getItem('usuarios'));
        console.log(this.usuarios)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.hero .title {
    color: #eee;
}

.is-black {
    cursor: not-allowed;
    pointer-events: none;
}
</style>
